import React from 'react';
import {Icon} from "react-materialize";

const ActionLink = ({value, label, handleClick}) => {
  return (
    <div onClick={() => handleClick(value)} className={'action-link'}>
      <p>{label}</p>
      <Icon>arrow_forward_ios</Icon>
    </div>
  )
}

export default ActionLink;